import {
    GET_LOCATION_SUCCESS,
    GET_LOCATION_FAIL,
    GET_LOCATION_CURRENT,
    GET_ADDRESSES_SUCCESS,
    GET_ADDRESSES_FAIL,
    PETITION_ADDRESSES
} from '../actions/types';

const initialState = {
    locations: [],
    location: null,

    addresses: [],
    petition_addresses: false,
};

export default function Location(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_LOCATION_SUCCESS:
            return {
                ...state,
                locations: payload.addresses
            };
        case GET_LOCATION_CURRENT:
            return {
                ...state,
                location: payload
            };
        case GET_LOCATION_FAIL:
            return {
                ...state
            };

        case GET_ADDRESSES_SUCCESS:
            console.log(payload.data);

            return {
                ...state,
                addresses: payload.data
            };
        case GET_ADDRESSES_FAIL:
            return {
                ...state
            };
        case PETITION_ADDRESSES:
            return {
                ...state,
                petition_addresses: true
            };

        default:
            return state
    }
}


